export function ValueComparison() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            The Smart Investment
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Most businesses make a costly mistake: paying thousands upfront for a website, then thousands more every month for SEO
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* Typical Costs */}
          <div className="bg-white rounded-2xl p-8 border-2 border-gray-300 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-red-500 rounded-xl flex items-center justify-center">
                <i className="ri-close-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Typical Costs</h3>
            </div>

            <div className="space-y-4 mb-6">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <span className="text-gray-700 font-medium">Website Build</span>
                <span className="text-xl font-bold text-gray-900">$3,000 - $10,000+</span>
              </div>
              <div className="flex items-center justify-center py-2">
                <i className="ri-add-line text-gray-400 text-2xl"></i>
              </div>
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <span className="text-gray-700 font-medium">SEO Retainer (Monthly)</span>
                <span className="text-xl font-bold text-gray-900">$500 - $2,500</span>
              </div>
            </div>

            <div className="border-t-2 border-gray-300 pt-4">
              <div className="flex items-center justify-between">
                <span className="text-lg font-bold text-gray-900">First Year Total</span>
                <span className="text-3xl font-bold text-red-500">$9,000 - $40,000+</span>
              </div>
            </div>

            <div className="mt-6 p-4 bg-red-50 rounded-lg border border-red-200">
              <p className="text-sm text-red-800 font-medium">
                <i className="ri-alert-line mr-2"></i>
                Large upfront cost + ongoing monthly fees
              </p>
            </div>
          </div>

          {/* Digital Age System */}
          <div className="bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl p-8 border-2 border-teal-600 shadow-xl relative overflow-hidden">
            {/* Badge */}
            <div className="absolute top-4 right-4 bg-white text-teal-600 px-4 py-2 rounded-full font-bold text-sm shadow-lg">
              Best Value
            </div>

            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center">
                <i className="ri-check-line text-teal-500 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-white">Digital Age System</h3>
            </div>

            <div className="space-y-4 mb-6">
              <div className="flex items-center justify-between p-4 bg-white/20 backdrop-blur-sm rounded-lg border border-white/30">
                <span className="text-white font-medium">Website Build</span>
                <div className="text-right">
                  <span className="text-xl font-bold text-white line-through opacity-75">$1,500</span>
                  <span className="text-2xl font-bold text-white ml-2">$0</span>
                </div>
              </div>
              <div className="flex items-center justify-center py-2">
                <i className="ri-add-line text-white/50 text-2xl"></i>
              </div>
              <div className="flex items-center justify-between p-4 bg-white/20 backdrop-blur-sm rounded-lg border border-white/30">
                <span className="text-white font-medium">Website + SEO (Monthly)</span>
                <span className="text-xl font-bold text-white">Starting at $399</span>
              </div>
            </div>

            <div className="border-t-2 border-white/30 pt-4">
              <div className="flex items-center justify-between">
                <span className="text-lg font-bold text-white">First Year Total</span>
                <span className="text-3xl font-bold text-white">$4,788</span>
              </div>
            </div>

            <div className="mt-6 p-4 bg-white/20 backdrop-blur-sm rounded-lg border border-white/30">
              <p className="text-sm text-white font-medium">
                <i className="ri-check-double-line mr-2"></i>
                No upfront cost + affordable monthly investment
              </p>
            </div>
          </div>
        </div>

        {/* Savings Highlight */}
        <div className="bg-gradient-to-r from-green-500 to-emerald-500 rounded-2xl p-8 text-white text-center shadow-xl">
          <div className="flex items-center justify-center gap-4 mb-4">
            <i className="ri-money-dollar-circle-line text-6xl"></i>
            <div className="text-left">
              <p className="text-lg font-medium opacity-90">Save up to</p>
              <p className="text-5xl font-bold">$35,000+</p>
              <p className="text-lg font-medium opacity-90">in the first year</p>
            </div>
          </div>
          <p className="text-xl">
            Get the same professional website and comprehensive SEO—without the massive upfront investment
          </p>
        </div>
      </div>
    </section>
  );
}